<template>
  <el-dialog
    title="門禁資訊"
    :visible="true"
    :close-on-click-modal="false"
    @close="$emit('close')"
  >
    <BaseElForm label-width="150px" label-position="left">
      <BaseElFormItem label="有效期間">
        <span>{{ displayData.validRange }}</span>
      </BaseElFormItem>
    </BaseElForm>

    <div slot="footer">
      <BaseElButton plain @click="$emit('close')">關閉</BaseElButton>
    </div>
  </el-dialog>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { get } from 'lodash'
import { formatDate } from '@/utils/date'

export default defineComponent({
  name: 'AguardAccessControlDialog',
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  emits: ['close'],
  setup (props) {
    // Compute display data from aguardAccessControl customInfo
    const displayData = computed(() => {
      const aguard = get(props.order, 'AppointmentOrder.customInfo.aguardAccessControl')
      const start = get(aguard, 'effectiveStartAt')
      const end = get(aguard, 'effectiveEndAt')
      return {
        validRange: `${formatDate(start, 'YYYY/MM/DD HH:mm')} - ${formatDate(end, 'YYYY/MM/DD HH:mm')}`,
      }
    })

    return { displayData }
  },
})
</script>

<style scoped lang="postcss"></style>
